import { Component, Input, OnInit } from '@angular/core';
import { ScreenBreakpointObserverService } from '../../shared/foundation/utils/breakpoint-observer.service';

@Component({
  selector: 'app-content-wrapper',
  templateUrl: './content-wrapper.component.html',
  styleUrls: ['./content-wrapper.component.scss'],
})
export class ContentWrapperComponent implements OnInit {
  @Input() title?: string;
  isMobileLayout = false;

  constructor(private bpObserverService: ScreenBreakpointObserverService) {}

  ngOnInit(): void {
    this.bpObserverService.screenSizeObserver.subscribe({
      next: (res) => {
        if (res.length <= 2) {
          this.isMobileLayout = true;
        } else {
          this.isMobileLayout = false;
        }
      },
    });
  }
}
